define('core/views/UsersCard',[
    'jquery',
    'underscore',
    'handlebars',
    'core/config',
    'core/bus',
    'core/utils/views',
    'core/views/common/HoverCard',
    'core/views/common/mixins/LocalScroll',

    'core/templates/usersCard',
], function (
    $,
    _,
    Handlebars,
    config,
    Bus,
    utils,
    HoverCard,
    LocalScrollMixin,

    usersCardTemplate
) {
    'use strict';

    var shouldAnonymize = function (user) {
        return user.get('isAnonymous') || user.get('isBlocked');
    };

    // UsersCard shows a list of users
    var UsersCard = HoverCard.extend({
        guestTextPartialName: 'cardOtherUserText',

        className: 'tooltip-outer upvoters-outer',

        initialize: function (options) {
            HoverCard.prototype.initialize.call(this, options);

            this.collection = this.collection || options.collection;
            this.session = options.session;

            // The total number of users in the set shown here.
            // This may be greater than the number in the given collection
            // if it exceeds the fetch limit, or if there are guests
            this.numUsers = options.numUsers;

            this.listenTo(this.collection, 'add', this.addUser);
            this.listenTo(this.collection, 'change:isBlocked', this.render);
            this.listenTo(this.collection, 'remove', this.removeUser);
            this.listenTo(this.collection, 'reset', this.render);
        },

        addUser: function (user) {
            if (shouldAnonymize(user)) {
                this.updateGuests();
            } else if (this.$listEl && this.$listEl.length) {
                this.$listEl.prepend(Handlebars.partials.cardUser(this.getUserTemplateData(user)));
                this.stopHighlightUsername();
            }
        },

        removeUser: function (user) {
            if (shouldAnonymize(user)) {
                this.updateGuests();
            } else {
                var userEl = this.$el.find('[data-username=' + user.get('username') + ']');
                if (userEl.length)
                    userEl.remove();
            }
        },

        // stop animation after 1.1s as the animation durations is 1s
        stopHighlightUsername: _.debounce(function () {
            var usernameEl = this.$el.find('.highlight');
            usernameEl.removeClass('highlight');
        }, 1100),

        getGuestCount: function () {
            return Math.max(this.numUsers - this.collection.reject(shouldAnonymize).length, 0);
        },

        updateGuests: function () {
            var guestEl = this.$el.find('[data-role=guest]');
            var guestCount = this.getGuestCount();
            var guestText = Handlebars.partials[this.guestTextPartialName]({
                guestCount: guestCount,
            });

            var data = {
                guestCount: guestCount,
                guestAvatarUrl: config.urls.avatar.generic,
                highlight: guestEl.length,
                guestText: guestText,
            };

            var html = Handlebars.partials.cardGuestUser(data);

            if (guestEl.length) {
                guestEl.replaceWith(html);
                this.stopHighlightUsername();
            } else if (this.$listEl && this.$listEl.length) { // if this is the first guest
                this.$listEl.append(html);
            }
        },

        getTemplateData: function () {
            return {
                users: _.invoke(this.collection.reject(shouldAnonymize), 'toJSON'),
                highlight: false,
            };
        },

        getUserTemplateData: function (user) {
            return _.extend({
                highlight: true,
            }, user.toJSON());
        },

        render: function () {
            // cleanup dom references
            delete this.pointEl;

            // do render
            this.$el.html(usersCardTemplate(this.getTemplateData()));

            HoverCard.prototype.render.call(this);
            this.$listEl = this.$el.find('.upvoters ul');

            this.updateGuests();
        },

        show: function () {
            // if there is are no users, or if the card is already visible,
            // nothing needs to be done
            if (!this.numUsers || this.isVisible())
                return;

            // show/render list of users
            HoverCard.prototype.show.call(this);

            Bus.trigger('uiAction:userCardShow');
        },

        // shows "bubble-speech" pointer at specified location.
        // currently only two locations are supported:
        // 'tl' - stands for top left
        // 'bl' - stands for bottom left
        showPoint: function (position) {
            var supportedPositions = ['tl', 'bl'];
            if (!this.pointEl) {
                this.pointEl = this.$el.find('.tooltip-point');
                this.pointEl.removeClass('hidden');
            }
            _.each(supportedPositions, function (pos) {
                this.pointEl.removeClass('point-position-' + pos);
            }, this);
            this.pointEl.addClass('point-position-' + position);
        },

        // Displays current view's element near the target element.
        // By default the position of the tooltip is above the target, but
        // if there is no space above, the tooltip will be displayed
        // below the target.
        moveTo: function (target, heightIncrease) {
            // Note: it is safe to call moveTo when element is hidden, i.e.
            // style=display:none. Looks like jQuery will make element visible,
            // compute its dimensions and hide again.
            if (!target) // if no target specified - there is no place to move to
                return;

            var posOffset = HoverCard.POSITION_OFFSET; // show tooltip with posOffset overlap on target
            var pos = target.offset();
            var el = this.$el;
            var elHeight = el.height();
            var containerPos = this.getContainerPosition();

            // animation is going to delay height increase, so we need to consider future height
            // in our calculations now.
            if (heightIncrease)
                // height doesn't include paddings/margings, so use +10 for it.
                elHeight += el.find('li.user').height() + 10;

            // try to position tooltip on top of the target
            if (pos.top - elHeight - posOffset >= 0 && pos.top - elHeight + containerPos.containerOffset.top >= containerPos.pageOffset) {
                el.css({
                    'bottom': containerPos.containerOffset.height - pos.top + posOffset,
                    'top': 'inherit',
                });
                this.showPoint('bl');
            } else { // if there is not space on a top, show tooltip below the target
                el.css({
                    'bottom': 'inherit',
                    'top': pos.top + posOffset * 2,
                });
                this.showPoint('tl');
            }
            el.css('left', pos.left - posOffset);
        },

        handleShowProfile: function (evt) {
            HoverCard.prototype.handleShowProfile.call(this, evt);

            var $target = $(evt.currentTarget);
            var username = $target.attr('data-username');

            Bus.trigger('uiCallback:showProfile', username);
        },

    }, {
        create: function (id, options) {
            return HoverCard.create(id, options, 'UsersCard', UsersCard);
        },
    });

    utils.mixin(UsersCard, LocalScrollMixin, {
        scrollMeasureSelector: '[data-role=content]',
    });

    return UsersCard;
});

